// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9e3a38c0","14":"7a4f9d9c","453":"70df4792","552":"103ae4de","606":"b7b3681a"}[chunkId] + ".chunk.js";
};